import { render } from "./FormDiccionario.vue?vue&type=template&id=23c0c79f&scoped=true"
import script from "./FormDiccionario.vue?vue&type=script&lang=js"
export * from "./FormDiccionario.vue?vue&type=script&lang=js"

import "./FormDiccionario.vue?vue&type=style&index=0&id=23c0c79f&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-23c0c79f"

export default script